import React from 'react';
import styled from '@emotion/styled';

import { COLORS } from '@/constants';
import { Container, Row, Col } from '@/components/grid';
import { H2 } from '@/components/type';
import RichText from '@/components/rich-text';

import ContactForm from './contact-form';
import { type HsiycContactFormBlock } from '@tac/sanity-client/types';
import { Box } from '@mui/material';

const Wrapper = styled.div`
  background-color: ${COLORS.GREY_ONE};
  color: ${COLORS.GREY_ELEVEN};
`;

const ContentCol = styled(Col)`
  text-align: center;
`;

const ContactFormBlock = ({ body, subject, heading, successMessage }: HsiycContactFormBlock) => {
  return (
    <Wrapper>
      <Container>
        <Row wrap="wrap">
          <ContentCol width={{ xs: 12, lg: 6 }} offset={[0, 0, 0, 3 / 12]}>
            {heading && (
              <Box mb={{ xs: 6, sm: 9 }}>
                <H2>{heading}</H2>
              </Box>
            )}
            {body && <RichText portableTextValue={body} />}
          </ContentCol>
        </Row>
        <ContactForm subject={subject} successMessage={successMessage} />
      </Container>
    </Wrapper>
  );
};

export default ContactFormBlock;
